"use strict";

var grid = {
  max: '1440px',
  gutter: '15px',
  columns: 24
};
module.exports = grid;